export default __webpack_public_path__ + "static/media/office.2f376b5c.jpg";